import { useMemo, useState } from "react";
import { useQuery, useQueryClient } from "react-query";
import {
  DocumentMagnifyingGlassIcon,
  UsersIcon,
  PlusIcon
} from "@heroicons/react/24/outline";
import Statistics from "../../components/legislation/cards/Statistics";
import CommitteeManagement from "../../components/legislation/modals/CommitteeManagement";
import LegislationOverview from "../../components/legislation/cards/LegislationOverview";
import { legislationsAPI } from "../../services/api";

import LegislationTable from "../../components/legislation/LegislationTable";
import LegislationModal from "../../components/legislation/modals/LegislationModal";
import { useFetch } from "../../hooks/useCallApi";
function LegislationPage() {
  const [openCommitteeModal, setOpenCommitteeModal] = useState(false);
  const [openNewLegislation, setOpenNewLegislation] = useState(false);

  const params = useMemo(
    () => ({
      section: 'resolution_ordinance',
    }),
    []
  )

  const { data: legislativeData, isLoading, refetch } = useFetch(
    ['resolution-ordinance', params],
    api => api.admin.legislation.getTabView(params)
  )

  const queryClient = useQueryClient();

  const refetchLegislativeDocuments = () => {
    queryClient.invalidateQueries(["legislative-documents"]);
  };

  const refetchLegislativeDocumentById = (documentId) => {
    queryClient.invalidateQueries(["legislation-detail", documentId]);
  };

  const latestNumber = useMemo(() => {
    const list = legislativeData?.data?.data || []
    if (!list.length) return null

    return [...list].sort((a, b) => {
      const [yearA, numA] = a.legislation_number.split('-')
      const [yearB, numB] = b.legislation_number.split('-')
      return yearA !== yearB ? Number(yearB) - Number(yearA) : Number(numB) - Number(numA)
    })[0]?.legislation_number
  }, [legislativeData])

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-9xl mx-auto p-2">

        {/* Header Section */}
        <div className="flex items-center justify-between mb-8">

          <div className="flex items-center space-x-4">
            <div className="flex items-center justify-center w-12 h-12 bg-blue-100 rounded-lg">
              <DocumentMagnifyingGlassIcon className="w-6 h-6 text-blue-600" />
            </div>

            <div>
              <h1 className="text-2xl font-bold text-gray-900">
                Legislation
              </h1>
              <p className="text-gray-600">
                Monitor legislative progress, committee reports, and policy changes.
              </p>
            </div>
          </div>

          <div className="flex items-center gap-3">
            <button
              className="flex items-center gap-2 bg-indigo-100 text-indigo-700 px-4 py-2 rounded-md text-sm font-medium"
              onClick={() => setOpenCommitteeModal(true)}
            >
              <UsersIcon className="w-4 h-4" />
              Committee Management
            </button>

            <button className="flex items-center gap-2 bg-blue-600 text-white px-4 py-2 rounded-md text-sm font-medium"
              onClick={() => setOpenNewLegislation(true)}>
              <PlusIcon className="w-4 h-4" />
              New Legislation
            </button>
          </div>

        </div>

        {/* Cards*/}
        <Statistics />


        <LegislationOverview />
        <LegislationTable />

      </div>

      {/* Modals */}
      {openCommitteeModal && (
        <CommitteeManagement setOpen={setOpenCommitteeModal} />
      )}

      {openNewLegislation && (
        <LegislationModal
          isOpen={openNewLegislation}
          onClose={() => setOpenNewLegislation(false)}
          mode="create"
          latestNumber={latestNumber}
          refetchLegislativeDocuments={refetchLegislativeDocuments}
          refetchLegislativeDocumentById={refetchLegislativeDocumentById}
        />
      )}

    </div>
  );
}

export default LegislationPage;
